var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FBF8F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16879 12.9116L15.0202 19.8304C15.2447 20.0569 15.6081 20.0565 15.8322 19.8292C16.0561 19.6019 16.0556 19.2337 15.831 19.0069L9.38746 12.5L15.8313 5.99304C16.0558 5.76629 16.0563 5.39829 15.8324 5.17095C15.7201 5.05698 15.5729 5 15.4257 5C15.279 5 15.1324 5.0566 15.0202 5.16978L8.16879 12.0884C8.06067 12.1973 8 12.3455 8 12.5C8 12.6544 8.06084 12.8025 8.16879 12.9116Z",
    fill: "#1B1D28",
    stroke: "#1B1D28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.ff66d79c8e04029de9708e5144544bfa.svg";
export { ForwardRef as ReactComponent };